import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import { compose } from "recompose";
import NextStopComplianceMap from "./Map";
import NextStopComplianceDetails from "./Details";
import ArrowBackIcon from "@material-ui/icons/KeyboardArrowLeft";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { getDeviationData } from "../NextStopComplianceUtills";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../../appMessages";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";

const styles = (theme) => ({
  subModule: {
    height: "100%",
    display: "flex",
  },
  mapComponent: {
    width: "60%",
    height: "100%",
    boxSizing: "border-box",
  },
  detailComponent: {
    width: "40%",
    height: "100%",
    boxSizing: "border-box",
  },
  header: {
    color: theme.TextColor,
    display: "flex",
    padding: "10px 0",
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontSize: "14px",
    textAlign: "center",
    lineHeight: "21px",
    fontWeight: "bold",
  },
  backButton: {
    color: theme.gridTextColor,
    cursor: "pointer",
  },
  backIcon: {
    verticalAlign: "middle",
    fontSize: "25px",
  },
  layoutTitle: {
    color: theme.HeaderSelectedText,
    display: "flex",
    justifyContent: "flex-end",
    width: "50%",
  },
});

class NextStopComplianceMapDetails extends React.Component {
  constructor(props) {
    super(props);
    this.terminalCode = this.props.userData.userProfile.terminal.code;
    this.state = {
      stopDetails: null,
      value: 0,
      stopIndex: 0,
      routeComplianceData: null,
      selectedRoute: null,
      dataUpdateInProgress: false,
    };
  }

  componentDidMount = () => {
    this.getRouteCompliancesData(
      this.props.nextStopComplianceSelectedRoute.routeId
    );
    this.setState({
      selectedRoute: this.props.nextStopComplianceSelectedRoute.routeId,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.terminalCode !== this.props.userData.userProfile.terminal.code) {
      this.terminalCode = this.props.userData.userProfile.terminal.code;
      this.props.goBack();
    }
    if (
      this.props.nextStopComplianceSelectedRoute.routeId !==
      this.state.selectedRoute
    ) {
      this.setState({
        selectedRoute: this.props.nextStopComplianceSelectedRoute.routeId,
        stopIndex: 0,
      });
      this.getRouteCompliancesData(
        this.props.nextStopComplianceSelectedRoute.routeId
      );
    }
  }

  getRouteCompliancesData = (selectedRoute) => {
    this.setState({ dataUpdateInProgress: true });
    getDataWithQueryString(
      "GetRouteComplianceData",
      `routeId=${selectedRoute}`
    ).then(
      (response) => {
        if (response.status >= 200 && response.status <= 400) {
          const routeComplianceData = response.data;
          routeComplianceData.actualStops.sort((a, b) => {
            return a.stopSequence - b.stopSequence;
          });
          if (
            routeComplianceData.stops.length > 0 &&
            routeComplianceData.actualStops.length > 0
          ) {
            this.setState({
              stopDetails: getDeviationData(
                routeComplianceData,
                this.state.stopIndex,
                this.terminalCode
              ),
              routeComplianceData: routeComplianceData,
              dataUpdateInProgress: false,
            });
          } else {
            this.setState({
              stopDetails: null,
              routeComplianceData: routeComplianceData,
              dataUpdateInProgress: false,
            });
          }
        } else {
          this.handleError();
        }
      },
      (error) => {
        this.handleError();
      }
    );
  };

  handleError = () => {
    this.props.enqueueSnackbar(
      MESSAGES.NEXT_STOP_COMPLIANCE.FETCH_DATA_FAILURE,
      { variant: "error" }
    );
    this.setState({
      stopDetails: null,
      routeComplianceData: [],
      dataUpdateInProgress: false,
    });
  };

  onStopClick = (stopIndex) => {
    if (
      stopIndex >= 0 &&
      stopIndex !== this.state.routeComplianceData.actualStops.length
    ) {
      const stopDetails = getDeviationData(
        this.state.routeComplianceData,
        stopIndex,
        this.terminalCode
      );
      this.setState({
        stopDetails: stopDetails,
        value: 1,
        stopIndex: stopIndex,
      });
      trackEvent(
        "NextStopComplianceSelectedStopDetail",
        this.props.userProfile,
        {
          stopDetails: stopDetails,
        }
      );
    }
  };

  onTabChange = (value) => {
    const tabValue = [
      "End of Day Route Compliance",
      "Driver Decision at Each Stop",
    ];
    this.setState({
      value: value,
    });
    trackEvent("NextStopComplianceSelectedTab", this.props.userProfile, {
      NextStopComplianceSelectedTab: tabValue[value],
    });
  };

  render() {
    const {
      classes,
      nextStopComplianceSelectedRoute,
      routeComplianceList,
      updateNextStopComplianceSelectedRoute,
    } = this.props;
    const { dataUpdateInProgress, routeComplianceData } = this.state;
    const selectedRoute = this.props.nextStopComplianceSelectedRoute.routeId;
    return (
      <React.Fragment>
        <header className={classes.header}>
          <div className={classes.backButton} onClick={this.props.goBack}>
            <ArrowBackIcon classes={{ root: classes.backIcon }} /> Back
          </div>
          <div className={classes.layoutTitle}>Next Stop Compliance Map</div>
        </header>
        <div className={classes.subModule}>
          <div className={classes.mapComponent}>
            <NextStopComplianceMap
              onStopClick={this.onStopClick}
              selectedRoute={selectedRoute}
              value={this.state.value}
              stopDetails={this.state.stopDetails}
              routeComplianceData={routeComplianceData}
              routeComplianceList={routeComplianceList}
              nextStopComplianceSelectedRoute={nextStopComplianceSelectedRoute}
              updateNextStopComplianceSelectedRoute={
                updateNextStopComplianceSelectedRoute
              }
            />
          </div>
          <div className={classes.detailComponent}>
            <NextStopComplianceDetails
              stopDetails={this.state.stopDetails}
              value={this.state.value}
              onStopClick={this.onStopClick}
              onTabChange={this.onTabChange}
              selectedRoute={selectedRoute}
              stopIndex={this.state.stopIndex}
              terminalCode={this.terminalCode}
              routeComplianceData={routeComplianceData}
              nextStopComplianceSelectedRoute={nextStopComplianceSelectedRoute}
              dataUpdateInProgress={dataUpdateInProgress}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(
  withStyles(styles),
  withTheme(),
  withUserProfile,
  withSnackbar
)(NextStopComplianceMapDetails);
